import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcGridFilter from '@grapecity/wijmo.grid.filter';
import { BaseService } from 'src/app/core/services/base/base.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { BentoAlertItemOptions } from '@bento/bento-ng';
import { environment } from 'src/environments/environment';
import StaffingratioAdminConfiguration from 'src/app/core/models/staffingration-admin-configuration.model';
import { BackendTokenClaims } from '../../../../models/tokenResponse';
import { FlagRequestBody } from 'src/app/core/models/staffingration-admin-configuration.model';
import { setSelectionRange } from '@grapecity/wijmo';
import { FilterType } from '@grapecity/wijmo.grid.filter';
import { FeatureToggleService } from 'src/app/core/services/feature-toggle/feature-toggle.service';
declare let TRAAC: any;
@Component({
  selector: 'app-admin-configurations',
  templateUrl: './admin-configurations.component.html',
  styleUrls: ['./admin-configurations.component.scss'],
})
export class AdminConfigurationsComponent {
  @ViewChild('filter', { static: true }) gridFilter: wjcGridFilter.FlexGridFilter;
  @ViewChild('flexGrid', { static: true }) flexGrid: wjcGrid.FlexGrid;
  @ViewChild('staffingRatioPeerGroupsSearchBtn', { static: false }) searchButton: ElementRef;

  alerts: BentoAlertItemOptions[] = [];
  enableClearFilter = false;
  currentSurveyYearOfFirm: string;
  data: wjcCore.CollectionView;
  isDataLoading: boolean = true;
  firmsFlagData: StaffingratioAdminConfiguration[] = [];
  originalFirmsFlagData: StaffingratioAdminConfiguration[] = [];
  firmsFlagGridData: StaffingratioAdminConfiguration[] = [];
  searchText = '';
  zeroOneMap: wjcGrid.DataMap;
  currentRecords: number = 0;
  totalRecords: number = 0;
  lastPressedKey: any = null;
  gridsSelectedRow = 0;
  gridsSelectedCol = 0;
  isQuickSightEnabled = false;

  constructor(
    private authService: AuthService,
    private service: BaseService,
    private featureToggleService: FeatureToggleService
  ) { }
  async ngOnInit(): Promise<void> {
    this.isDataLoading = true;
    let zeroOneMapStructure = [
      { value: true, display: 'true' },
      { value: false, display: 'false' },
      { value: null, display: 'false' },
    ];

    this.zeroOneMap = new wjcGrid.DataMap(zeroOneMapStructure, 'value', 'display');

    await this.getCurrentSurveyYear();
    await this.getAllFlags();
    await this.featureToggleService.getFeatureValue('QUICKSIGHT').then((val) => (this.isQuickSightEnabled = val));
    if (this.isQuickSightEnabled) {
      this.trackAdminConfigurationClickEvent();
    }
    this.firmsFlagData.forEach((val) => this.originalFirmsFlagData.push(Object.assign({}, val)));
    this.totalRecords = this.firmsFlagData.length;
    this.data = new wjcCore.CollectionView(this.firmsFlagData);
    this.data.collectionChanged.addHandler(() => {
      this.gridFilter.getColumnFilter('firmName').filterType = wjcGridFilter.FilterType.Both;
      this.gridFilter.getColumnFilter('dateTimeReportImported').filterType = wjcGridFilter.FilterType.Both;
      this.gridFilter.getColumnFilter('dateTimeReportExported').filterType = wjcGridFilter.FilterType.Both;
    });
    this.currentRecords = this.totalRecords;
  }
  gridInitialized(flexGrid: wjcGrid.FlexGrid, filter: wjcGridFilter.FlexGridFilter) {
    flexGrid.rows.defaultSize = 42;
    flexGrid.columnHeaders.rows.defaultSize = 42;
    // flexGrid.select(-1,-1);
    this.flexGrid = flexGrid;
    filter.defaultFilterType = wjcGridFilter.FilterType.Value;
    flexGrid.hostElement.addEventListener('keydown', (e) => {
      this.lastPressedKey = e.code;
    });

    const filterDropdownSelector = '.wj-dropdown-panel';
    const filterButtonSelector = '.wj-elem-filter';
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (target && (target.matches(filterButtonSelector) || target.closest(filterButtonSelector))) {
        return;      }
      const filterDropdown = target.closest(filterDropdownSelector);
      if (filterDropdown) {
        e.stopPropagation();
      }
    }, true); 
  }
  focusOnGrid(flexGrid, event) {
    flexGrid.select(0, 0);
  }
  onFilterChange() {
    this.enableClearFilter = true;
  }
  onFilterApply() {
    this.currentRecords = this.flexGrid.rows.length;
  }
  onCheckBoxChange(row) {
    row.isUpdating = true;
    let requestBodyArray = [];
    let requestBody = new FlagRequestBody();
    requestBody.firmId = row.firmId;
    requestBody.surveyYear = row.surveyYear;
    requestBody.firmDataValid = row.firmDataValid == null ? false : row.firmDataValid;
    requestBody.firmDisabled = row.isFirmDisabled == null ? false : row.isFirmDisabled;
    requestBody.peersDisplayed = row.isPeerDisplayed == null ? false : row.isPeerDisplayed;
    requestBody.reportsReady = row.reportReady == null ? false : row.reportReady;
    requestBody.peersSubmitted = row.peerSubmitted == null ? false : row.peerSubmitted;
    requestBody.firmId = row.firmId;
    requestBodyArray.push(requestBody);
    this.service
      .put(environment.FIClientBaseEndpoint + 'v1/staffingratio/subscription/flags', requestBodyArray)
      .subscribe(
        (result) => {
          this.isDataLoading = false;
          row.isUpdating = false;
          this.alerts.push({
            type: 'success',
            msg: 'Data saved successfully.',
            timeout: 2500,
            closeable: true,
          });
          let cell = this.flexGrid.cells.getCellElement(this.gridsSelectedRow, this.gridsSelectedCol);
          cell.focus();
        },

        (error) => {
          row.isUpdating = false;
          this.isDataLoading = false;
          this.alerts.push({
            type: 'warning',
            msg: error.error,
            closeable: true,
          });
          let cell = this.flexGrid.cells.getCellElement(this.gridsSelectedRow, this.gridsSelectedCol);
          cell.focus();
        }
      );
  }
  getCurrentSurveyYear() {
    this.isDataLoading = true;
    return this.service
      .get(environment.FIClientBaseEndpoint + 'v1/staffingratio/surveyyear/' + this.firmId, '')
      .toPromise()
      .then(
        (result) => {
          this.currentSurveyYearOfFirm = result;
        },
        (error) => {
          this.alerts.push({
            type: 'warning',
            msg: error.error.message,
            closeable: true,
          });
        }
      );
  }
  getAllFlags() {
    return this.service
      .get(environment.FIClientBaseEndpoint + 'v1/staffingratio/subscription/flags/' + this.currentSurveyYearOfFirm, '')
      .toPromise()
      .then(
        (result) => {
          this.firmsFlagData = result;
          this.firmsFlagGridData = this.firmsFlagData;
        },
        (error) => {
          this.isDataLoading = false;
          this.alerts.push({
            type: 'warning',
            msg: error.error.message,
            closeable: true,
          });
        }
      );
  }
  private get firmId(): number {
    const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
    return backendTokenClaims.userDDO.firmID;
  }
  searchStaffingRatioFirm() {
    this.firmsFlagGridData = this.firmsFlagData.filter(
      (element) => element.firmName.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0
    );
    this.data = new wjcCore.CollectionView(this.firmsFlagGridData);
  }
  initFilter() {
    this.gridFilter.showSortButtons = false;
  }

  handleSelectionChanged(sender: wjcGrid.FlexGrid, args: wjcGrid.CellRangeEventArgs) {
    this.gridsSelectedCol = args.col;
    this.gridsSelectedRow = args.row;
    if (this.lastPressedKey == 'ArrowDown' || this.lastPressedKey == 'ArrowUp') {
      let selectedCell = args.panel.getCellElement(args.row, args.col);
      console.log('selected ce', selectedCell);
      if (selectedCell) {
        selectedCell.scrollIntoView({
          block: 'center',
          behavior: 'auto',
          inline: 'nearest',
        });
      }
    }
  }

  handleKeyDown(flexGrid, event) {
    if (event.code === 'Space') {
      event.preventDefault();
      let cell = flexGrid.cells.getCellElement(this.gridsSelectedRow, this.gridsSelectedCol);
      let input = cell.querySelector('input');
      input.click();
      cell.focus();
    }
  }
  trackAdminConfigurationClickEvent() {
    if (this.isQuickSightEnabled) {
      const backendTokenClaims: BackendTokenClaims = this.authService.getBackendTokenClaims();
      TRAAC.track(
        TRAAC.keyValue('Admin Configuration click', {
          firmId: backendTokenClaims.userDDO.firmID,
          userId: backendTokenClaims.userDDO.userID,
          eventName: 'Admin Configuration click',
        }).build()
      );
    }
  }




}
